import { getAuthentication } from '@/hooks/useAuthentication';
import OnBoardingContainer from '../../../components/on-boarding';
import { Step1 } from '../../../graphql/generated/graphql';
import { fetchOnBoardingStep1, onInitOnBoarding } from '../../../services/on-boarding/onboarding.service';
import { useOnBoarding } from '../hooks/useOnBoarding';
import { useCallback, useEffect } from 'react';

export default function OnBoardingStep1() {
  const { response, handleNext } = useOnBoarding<Step1>({
    fetchFn: useCallback(fetchOnBoardingStep1, []),
  });

  const onInit = useCallback(async () => {
    const { user } = getAuthentication();
    if (!user) return;
    await onInitOnBoarding(user.id);
  }, []);

  useEffect(() => {
    onInit();
  }, [onInit]);

  return (
    <OnBoardingContainer
      image={response.content?.image?.data?.attributes?.url || ''}
      step={0}
      title={response?.content?.title || ''}
      description={response?.content?.description || ''}
      button={{
        text: response?.content?.button?.text || '',
        onClick: () => handleNext(),
      }}
    />
  );
}
